import cn from 'classnames';
import { CSSProperties, FC } from 'react';
import { CiEdit } from 'react-icons/ci';
import { FaRegCheckCircle } from 'react-icons/fa';
import { MdDeleteForever } from 'react-icons/md';
import { IconButton } from '../../components/icon-button/icon-button';
import { InlineInputs } from '../../components/inline-inputs/inline-inputs';
import { Input } from '../../components/input/input';
import { LangType } from '../../helpers/lang';
import { LangInput } from '../lang-input/lang-input';
import { useSorterItem } from '../sorter/use-sorter-item';
import s from './editable-label.module.css';
import { EditableLabelProps, useEditableLabel } from './use-editable-label';

export const EditableLabel: FC<EditableLabelProps> = (props) => {
  const {
    t,
    editValue,
    handleConfirm,
    handleEdit,
    isEditing,
    isLangType,
    onKeyDown,
    editRef,
    displayRef,
    other,
    label,
    sortable,
    id = '',
    setEditValue,
    onDelete,
    isDisabled,
  } = useEditableLabel(props);

  const { sortStyle, setNodeRef, listeners, attributes, isDragging } = useSorterItem({
    id,
    disabled: !sortable,
  });

  const style: CSSProperties = {
    ...sortStyle,
    opacity: isDragging ? 0.5 : 1,
    cursor: sortable ? 'grab' : 'default',
  };

  if (isEditing && !isDisabled) {
    return (
      <InlineInputs className={s.input} ref={editRef} onClick={(e) => e.stopPropagation()}>
        {isLangType ? (
          <LangInput
            value={editValue as LangType}
            onChange={setEditValue}
            autoFocus
            onKeyDown={onKeyDown}
          />
        ) : (
          <Input
            autoFocus
            value={editValue as string}
            onChange={(e) => setEditValue(e.currentTarget.value)}
            onKeyDown={onKeyDown}
          />
        )}
        <IconButton tooltip={t('Сохранить')} onClick={handleConfirm}>
          <FaRegCheckCircle />
        </IconButton>
      </InlineInputs>
    );
  }

  return (
    <div
      {...other}
      className={cn(s.label, props.className)}
      ref={setNodeRef || displayRef}
      style={style}
      draggable={sortable}
      {...attributes}
      {...listeners}
    >
      {label}
      {!isDisabled && (
        <>
          {onDelete && (
            <IconButton tooltip={t('Удалить')} size="sm" variant="secondary" onClick={onDelete}>
              <MdDeleteForever />
            </IconButton>
          )}
          <IconButton
            tooltip={t('Редактировать')}
            size="sm"
            variant="secondary"
            onClick={handleEdit}
          >
            <CiEdit />
          </IconButton>
        </>
      )}
    </div>
  );
};
